import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "mobile-signature-public-gateway",
  standalone: true,
  template: "",
})
export class MobileSignaturePublicGatewayComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const token = this.resolveToken();
    if (!token) {
      window.location.replace(`${window.location.origin}/#/e-signature/public`);
      return;
    }

    const encodedToken = encodeURIComponent(decodeURIComponent(token));
    window.location.replace(`${window.location.origin}/#/e-signature/public/${encodedToken}`);
  }

  private resolveToken(): string | null {
    let current: ActivatedRoute | null = this.route;
    while (current) {
      const token = current.snapshot.paramMap.get("token")?.trim();
      if (token) {
        return token;
      }
      current = current.parent;
    }

    const queryToken = this.route.snapshot.queryParamMap.get("token")?.trim();
    return queryToken || null;
  }
}
